// All needed imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Form1Module } from './form1-travel-leisure/form1.module';
import { Form2Module } from './form2-travel-sport/form2.module';
import { Form3Module } from './form3-travel-particular/form3.module';
import { Form4Module } from './form4-legal-particular/form4.module';
import { Form5Module } from './form5-legal-owner/form5.module';
import { Form6Module } from './form6-travel-students-incoming/form6.module';
import { BaseComponent } from './base-component/base.component';

@NgModule({
  // Declarate the needed components
  declarations: [ BaseComponent ],
  // Indicate the modules which will be used in other modules
  exports: [ BaseComponent ],
  // Indicate the modules which will be used in other modules
  imports: [
    CommonModule,
    Form1Module,
    Form2Module,
    Form3Module,
    Form4Module,
    Form5Module,
    Form6Module
  ],
  // providers: [ BasesService ]
  providers: []

})
export class PUAInsurancesModule { }
